import React from "react";
import { format } from "date-fns";

import DataTable from "../../common/DataTable";
import ColumnHeader from "../../common/ColumnHeader";
import { dateSortComparator } from "../../../utils/date";

const IccidInventoryList = ({
  data,
  meta,
  client,
  loading,
  handlePageChange,
  handleColumnClick,
  handlePageSizeChange,
  ...props
}) => {
  const columns = [
    { field: "id", headerName: "ID", flex: 1, sortable: false },
    {
      field: "iccid",
      headerName: "ICCID",
      minWidth: 200,
      flex: 3,
      sortable: false,
      renderHeader: () =>
        client ? (
          <ColumnHeader
            label={"ICCID"}
            handleClick={() => handleColumnClick("iccid")}
          />
        ) : (
          "ICCID"
        ),
    },
    {
      field: "mdn",
      headerName: "MDN",
      minWidth: 160,
      flex: 2,
      sortable: false,
      renderHeader: () =>
        client ? (
          <ColumnHeader
            label={"MDN"}
            handleClick={() => handleColumnClick("mdn")}
          />
        ) : (
          "MDN"
        ),
    },
    {
      field: "classification",
      headerName: "Classification",
      minWidth: 140,
      sortable: false,
    },
    {
      field: "archive",
      headerName: "Archived",
      sortable: false,
    },
    {
      field: "created_at",
      headerName: "Created At",
      minWidth: 200,
      filterable: false,
      flex: 3,
      sortable: false,
      valueGetter: (params) => params.row.created_at || null,
      valueFormatter: (params) =>
        params.value &&
        `${format(new Date(params.value), "MMMM d, y hh:mm a")}`,
      sortComparator: dateSortComparator,
    },
    {
      field: "last_updated",
      headerName: "Last Updated",
      minWidth: 200,
      filterable: false,
      flex: 3,
      sortable: false,
      valueGetter: (params) => params.row.last_updated || null,
      valueFormatter: (params) =>
        params.value &&
        `${format(new Date(params.value), "MMMM d, y hh:mm a")}`,
      sortComparator: dateSortComparator,
    },
  ];

  return (
    <DataTable
      disableColumnFilter
      loading={loading}
      data={data}
      columns={columns}
      metaData={meta}
      handlePageChange={handlePageChange}
      handlePageSizeChange={handlePageSizeChange}
      filterMode={client ? "client" : "server"}
      client={client}
      {...props}
    />
  );
};

export default IccidInventoryList;
